import Service from '@ember/service';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import { ParsedTreeBranchNode } from 'cio/models/campaign';

interface ExitToDeleteMeta {
  action: ActionModel;
  branch: ParsedTreeBranchNode;
  branchId: string;
  pathIndex: number;
}

export default class VisualWorkflowBuilderService extends Service {
  _vwbComponent: Component<any> | null = null;
  _vwbActionsComponent: Component<any> | null = null;
  _vwbCanvasComponent: Component<any> | null = null;

  exitToDeleteMeta: ExitToDeleteMeta | null = null;

  @action
  selectExitToDelete(actionModel: ActionModel, branch: ParsedTreeBranchNode, branchId: string, pathIndex: number) {
    this.set('exitToDeleteMeta', {
      action: actionModel,
      branch,
      branchId,
      pathIndex,
    });
  }

  @action
  resetExitToDelete() {
    this.set('exitToDeleteMeta', null);
  }

  @action
  registerVWBActionsComponent(vwbActions: Component<any>) {
    this.set('_vwbActionsComponent', vwbActions);
  }

  @action
  unregisterVWBActionsComponent() {
    this.set('_vwbActionsComponent', null);
  }

  @action
  registerVWBComponent(vwb: Component<any>) {
    this.set('_vwbComponent', vwb);
  }

  @action
  unregisterVWBComponent(vwb: Component<any>) {
    if (this._vwbComponent === vwb) {
      this.set('_vwbCanvasComponent', null);
    }
  }

  @action
  registerVWBCanvasComponent(vwbCanvas: Component<any>) {
    this.set('_vwbCanvasComponent', vwbCanvas);
  }

  @action
  unregisterVWBCanvasComponent(vwbCanvas: Component<any>) {
    if (this._vwbCanvasComponent === vwbCanvas) {
      this.set('_vwbCanvasComponent', null);
    }
  }

  @action
  redrawConnectingLines() {
    if (!this._vwbActionsComponent) {
      return;
    }

    return (this._vwbActionsComponent as any).redrawConnectingLines();
  }

  @action
  centerCanvas() {
    if ((this._vwbComponent as any)?.centerCanvas != null) {
      (this._vwbComponent as any).centerCanvas();
      return;
    }

    if (!this._vwbCanvasComponent) {
      return;
    }

    return (this._vwbCanvasComponent as any).centerCanvas();
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'visual-workflow-builder': VisualWorkflowBuilderService;
  }
}
